import React,{Component} from "react";

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Input,
  Col,
  Button,
  Alert
} from "reactstrap";
import axios from 'axios';
import { Redirect, withRouter } from "react-router-dom";
import Vimeo from '@u-wave/react-vimeo';
import NotificationAlert from "react-notification-alert";
import API,{base} from "api.js";
import { Player, BigPlayButton } from 'video-react';
import ReactPlayer from 'react-player';
import cookie from 'react-cookies';
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import {store,persistor} from 'store/index';
import Unauthorized from 'views/Unauthorized.jsx';

class ShowVideo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoData:[],
      currentQuestion:1,
      isRecording: false,
      blobURL: '',
      isBlocked: false,
      type:'',
      comment:'',
      error:false,
      userId:null,
      commentData:[],
      loadMore:false
    };
  }
  


  componentDidMount() {
    API({
      method: 'GET',
      url: `stgy-video/${this.props.match.params.id}`
    }).then(data => {

      if (data.status === 208) {
        console.log('unauthorized');
        this.props.history.push('/admin/unauthorized');
      } else if (data.status === 200) {
        let loadMore = true;
        if(data.data.data.comment.length < 10){
          loadMore = false;
        }

        if (data.status === 200) {
          this.setState({'videoData':data.data.data,'commentData':data.data.data.comment,loadMore:loadMore});
        }

        API({
          method: 'GET',
          url: 'user-data-get/id'
        }).then(data => {
          let userId = data.data.user.id;
          this.setState({userId:userId});
        }).catch(()=>{ });
      }
    }).catch(()=>{  });
  }

  loadMoreComment = ()=>{
    API({
      method: 'GET',
      url: 'videoComment/'+this.props.match.params.id+"?skip="+this.state.commentData.length
    }).then(data => {
      console.log([...this.state.commentData,...data.data])
      let loadMore = true;
      if(data.data.length < 10){
        loadMore = false;
      }
        this.setState({'commentData':[...this.state.commentData,...data.data],loadMore:loadMore});
      
      
    }).catch(()=>{
      
    }); 
  }

  changeComment = (e) => {
    let { name, value } = e.target;
    this.setState({ [name] : value });
  }

  addComent = async () => {
    var bodyFormData = new FormData();
    bodyFormData.set('comment', this.state.comment);
    bodyFormData.set('video_id', this.props.match.params.id);
    let res = null;
    try{
      res = await API({
        method: 'POST',
        url: 'add/comment-stgy',
        data: bodyFormData,
      })
    }catch(error) {
        console.log(error);
    };
    
    console.log(res);
    if(res){
      console.log(res);
      console.log(res.data);
      if (res.status === 200) {
          this.setState({commentData:res.data.data.comment,comment:''});
         this.notify(1,res.data.message);
        console.log("Comment saved successfully");        
      }
    }

  }

  notify = (type,message) => {
    
    switch (type) {
      case 1:
        type = "success";
        break;
      case 2:
        type = "danger";
        break;
      default:
        break;
    }
    var options = {};
    options = {
      place: 'tr',
      message: (
        <div>
          <div>
            {message}
          </div>
        </div>
      ),
      type: type,
      icon: "now-ui-icons ui-1_bell-53",
      autoDismiss: 7
    };
    this.refs.notificationAlert.notificationAlert(options);
  };

  deleteComment = async (e,id) => {
    console.log(id);
    var bodyFormData = {'id':id,'video_id':this.props.match.params.id};
    let res = null;
    try{
      res = await API({
        method: 'Delete',
        url: 'delete/comment-stgy',
        data: bodyFormData
      })
    }catch(error) {
        //this.setState({error:{error} });
    };
    
    console.log(res);
    if(res){
      console.log(res);
      console.log(res.data);
      if (res.status === 200) {
        this.notify(1,res.data.message)
        this.setState({commentData:res.data.data.comment});
        console.log("Comment saved successfully");        
      }
    }
  }

  comment = () => {
    //this.setState({currentQuestion:this.state.currentQuestion + 1,type:this.state.questionData[this.state.currentQuestion+1].subcategory_id});
    this.forceUpdate();
  }

  
  render() {
    return (
      <>
      <NotificationAlert ref="notificationAlert" />
        <div className="content">
          <Row>
            <Col xs={12}>
              <Card>
                <CardHeader>
                {this.state.error && <Alert color="danger" >{this.state.error}</Alert>}
                  <CardTitle className="text-center">
                    <h2>{this.state.videoData.title}</h2>
                    <span className="subtitle">{this.state.videoData.description}</span>
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <Row>     
                  <Col xs={12} className="videoOuter">
                    <ReactPlayer url={this.state.videoData.link} vimeo="true" controls />
                  </Col>
                  </Row>
                  {/* <div className="videoComnts">
                    <div className="commentArea">
                        <Input type="textarea" name="comment" value={this.state.comment} onChange={(e) => (this.changeComment(e))}  />
                        <Button color="primary" onClick={this.addComent}>Add Comment</Button>
                    </div>
                      <div className="postedComments">
                        {this.state.commentData.map((val, key) => {
                          if (val.user !== null) {
                            return (
                              <React.Fragment key={key}>
                                <div className="pComment">
                                  <h3 className="comment-user">
                                    <img style={{width: '57px',height: '57px',borderRadius:'85px'}} src={(val.user.image)?base+val.user.image:"data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAMAAACahl6sAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAG2YAABzjgAA+swAAIT6AAB5gQAA/RMAADBtAAASKQ0eJk4AAAMAUExURevr7Jydn5manJucnuPj5JiZm9vb3PT09MvLzMLCw5GSlPr6+qeoqdXV1tHR0rW1trW2uKusrbi4urO0tLq6vKiqq7e4uLW2tqGipLm6ury8vr6+vr+/wLu8vM7OztDQ0cjJytjY2dTU1aipqqqrrMXGxqanqKmqq6Wmp9LT062usKSlprS0ta2trra2t6ytrqWmqK2ur66vsK6ur7CwsbOztK+vsK+wsbKys7GxsqOkpqOkpZ6foampq6qqrJ2eoKenqaysraKjpZqbnbi4uaKjpKSlp5eYmqioqqurrKChory8vKGio6amqKCho7Gys7CxsrGysrKzs5+gop+gobS1tbq6u7e3uLCxsbKztLi4uJWWmJaXmba3t7i5ub29vZWXmZSWmLq6upOVl5SVl7m5up6foLq7u7u7vJqcnZOUlpeZm5aYmpKUlry8vZKTlpGTlZCRlJCRk6ytr9bX197e3q+vsb2+v8DAweDh4bOztebm5ujp6e/v756eoP///4CAgIGBgYKCgoODg4SEhIWFhYaGhoeHh4iIiImJiYqKiouLi4yMjI2NjY6Ojo+Pj5CQkJGRkZKSkpOTk5SUlJWVlZaWlpeXl5iYmJmZmZqampubm5ycnJ2dnZ6enp+fn6CgoKGhoaKioqOjo6SkpKWlpaampqenp6ioqKmpqaqqqqurq6ysrK2tra6urq+vr7CwsLGxsbKysrOzs7S0tLW1tba2tre3t7i4uLm5ubq6uru7u7y8vL29vb6+vr+/v8DAwMHBwcLCwsPDw8TExMXFxcbGxsfHx8jIyMnJycrKysvLy8zMzM3Nzc7Ozs/Pz9DQ0NHR0dLS0tPT09TU1NXV1dbW1tfX19jY2NnZ2dra2tvb29zc3N3d3d7e3t/f3+Dg4OHh4eLi4uPj4+Tk5OXl5ebm5ufn5+jo6Onp6erq6uvr6+zs7O3t7e7u7u/v7/Dw8PHx8fLy8vPz8/T09PX19fb29vf39/j4+Pn5+fr6+vv7+/z8/P39/f7+/v///zfARREAAAeqSURBVHja7N3xVxJZFMBxQAQVilzPSTslBxcDdwdtBQRBDQUFBYNMDTcoNLAMM7QD23JozvvX94cJZBhQZ+bdO2/26F/Q59wv8K48JwP5n/wY7iH3kHvIPYT6D89bLBazfiF8Y+T09PT09MOHzc3Nd+8yeoTwb99+/PjkSbfj8eN83qYPSCOTOTs7O3veEP69UkcegEIdMpPJCI6zz5/f9p9HPp9//97KMsTwLZO5o2Nh4RmrkHrpmxzHwsICzyLEWSq1IXd1TE6aWYNYSqVSqSRzHpOTDsdDliC2ksBQ4HA4zOxA6iURRJ7DccizAbE9fVpyNXhlXTkcjsNDHxMQKyGEWBV35Tg89Pl8rKTVUtHVoc/n89mYgPBK3686Dt8EIcQwMzOjKUTF+1XHMbG0tLT095s3y8vL77WCqHq/Ehy+Lsdybm9aC4irRKGrLkcut7cXiUTQIS1588jfPo/cXiQSibxGhtTpdyU4kCElyq/zXMdx9AwT0qI+j1zbEQwiQmyUX+fXXR0Fg0EXGsQK1dXRUTAYDIbRIJBdBYNhNIgFsqtgOBx2IkFguwqHQyEcSAu2q3AICwLcVSjEh1oYEPCuQgbix4A4obsK+QmPAwHtKhTy+3+gvEacsF2F/H5/wIAIAevK7/cHAhgQgPNuzzwCgcAiFgSoK3/bgQWhuUdJuwosYkGgu1pcnDdgQCju5wPmMY8CAeyqPY/5+To8BKErPAjY50fb8QIHAnIu6Z7HCxwI0Lmk24ECge8KB4LQ1YuNDYS3X4SuNjbGESAIXW2M40DAuxofH0c4ayF0hQNB6AoJAt8VDgShq/GdHQwIYFfteezMIkCgzrsiBwZkhPp+LulqFgXyB/X9XDoPFEgTviscCE99P+/+/PjlwIAQ6vu5dB4vX2JAALvaaTu8OBCoc0m7q5deHAjYuaQzD68fAwJ3Luk4vC4MyAh4V17vAwxIE7orr9fLY0AIdFde7xpBg8B09cuBCAHtyrvmxoLAdrXm/h0DUgfvas3tdvPQEBdCV2632+3eHgWFwL9ftR12+yYg5CfIfi7pyu3ettvtdkAI2B4lnYfdbndBQiD28wGO9XUwiAFmP5e8zu0CxGOFgrgQu1pf93hcUJA84HlX/DoXIDkoCNB+3r8rj8fjgYIA7ef9u4KGoHXl8XheAUKAzyXdXXlezcFBwM8lXV29moODoHY1BwfB7QoSgtoVIARuj+rXFTAEtCvxPJKPoCBm1K6SyZ9gx3jorrodc0kObh/B7CrJzQJCELviZA1EJsQAtp9LuwKFENA9SjwPbhoSYgbbzwVGl0PeQGT/gg5sP+/tipuFhRCkruQORD5kFPa8qzAsJb/Ehj3v/uqKM8NDSANmPxd11cD5fgS8K5Q/3yOE2L7l9vYWALpKPuI4jsP7M3DhB+JcovyBbmoeJ0K/K45oASG0u0py09pAND7v0oM0qe7nSU4zCKG7R2kJofw5yGsFcVLcz1UOROXztah2pSWE6vkqatUO0qS2n3McFyXaQYiP2h6l0qH6qYCU9nMuGmUBon6P4qLRh9pCrJS6UjsQ9Q+cXKKwR3HRaPQfrSGESlfRFaI5pK7284OKg8aDiyl0tcIEpKV4j6LooPIoaYParlZ4NiBE2X5+7fiXMAIh6rpaIcxAeDVdUXHQem78A/n7ecfRYAlCphXsURTnQfG/JJC/RwkO9iCy9yjBEWcNoqyrlTiTEPldxZmEKOgqHt9iDyL782MlHo9vsQeRtZ9fO5iDyNyjOg72IIq62tqaYg0ib4+6drAJkd3VFJMQBV1NTe2yC5HTFZOQO+9R3fPYZQ4iu6spwcEq5PY9StTV7m6WLYjtVFlXu9nsCDMQi9+ruKtsNptOp9N/WTWHmJ/I2s8l88im0+n0/v7+Qc6mHcSiZI8a4Dg4OFhdVXGnRjHks9I9StpVx7G6uvrpU8yJCHmudD+/cR6CIxaLxR5gQJT/3ufOjljMaDQ6ASHN18q+P5fRVcdhNBqNQ9tWAEhL+ffnCuZhNBqNQ0NDQ0N+qpCmyu85lTu+fEkkEnYLDcio6u/PFXbVcSQSiYTJ5FQFeU7le0518xAcJpPJNKMMUqL0/Tk1h2l4eHh4RB6kPkHlHvKA827HsS/bMXx+nvqtdUcItfvt9OcxfH6eSqVSqa8/boU06d2/AnR8LRaLN0Pq9O6339aVckfqa7FYLB7fBKF0DxlhHsXj42PjQEgIqqspCEehUBgA8dG5347S1fFxoVAo2PpCWrrqqlAoFE5OWn0gBr11VTg5Oan0gdC63w45j1Svo2KVQujdQ8bq6qRSqVQkkAlq95DxuqpUKmUJhNb9dsyuKpVyeVQC0WNX5XK52gOx6LKrcrlabYghE5Tut+N2VS5Xq3YxhNo9ZNyuqtXqhQhipXS/HburavVCDKkzvUcN7qp60QPZ1GtXFxc1EYTV/fwaMmgetV4Iu/v5jV3VarW6CML2fj64q1qt9mc3hPX9fPA8ape9ED3sUX3mcXl5KYboY4/q5xgTQdjfz/t31QvRb1djYz0QvXYlhbC/n/ftqgeinz1KMo8eiG72KKlDBNHPHtXbVT+ILrsaG7vqgei0q6ur770QfXZ19V2A/DcAHpmC7NcZ4/wAAAAASUVORK5CYII="} />&nbsp;&nbsp;{val.user.first_name}
                                  </h3>
                                  <p>{val.comment}</p>
                                  {val.user_id === this.state.userId  && <Button onClick={(e) => (this.deleteComment(e,val.id))} outline color="danger">Delete</Button>}
                                  <br/><small>{val.aus_date}(AEDT)</small>
                                  <hr />
                                </div>
                              </React.Fragment>        
                            );
                          }
                        })}
                        {this.state.loadMore && <button className="btn" onClick={(e)=>{this.loadMoreComment();}}>Load More</button>}
                      </div>
                  </div> */}
                </CardBody>
              </Card>
            </Col>
            {/* <Col xs={12}>
              <div className="bottomBtns">
                
              </div>
            </Col> */}
          </Row>
        </div>
      </>
    );
  }
}

export default ShowVideo;
